import {combineReducers} from 'redux';

import results from './search_reducer';
import isActive from './isActive_reducer';
import searchTerm from './search_term';
import changeNumber from './changeNumber-reducer';

export default combineReducers({results, isActive, searchTerm, changeNumber});